import { API } from '@/modules/api-service/api-service';
import type { Core } from '@strapi/types';

export const getTours = async () => {
	const { data: response } =
		await API().get<Core.Helpers.Controllers.GetResponseBody<'api::take-a-tour.take-a-tour', 'getTours'>>('/take-a-tour');

	return response;
};
